import type { ThreadSummary } from '../../store/types'
import { replyCountLabel } from './threads'

// The thread summary under a channel message, Slack-style:
//   (D)(S) 4 replies  Last reply 5m ago
// Faces are initials (we have no avatars): the most recent repliers, agents
// tinted like agent bubbles. The whole row is one button that opens the thread.
export function ThreadSummaryRow({
  summary,
  lastReplyAgo,
  unread,
  onOpen,
}: {
  summary: ThreadSummary
  // Relative time of the last reply ("5m", "now").
  lastReplyAgo: string
  // You follow this thread and it has replies you haven't read.
  unread?: boolean
  onOpen: () => void
}) {
  const when = lastReplyAgo === 'now' ? 'just now' : `${lastReplyAgo} ago`
  return (
    <button
      type="button"
      className={`msg-thread-summary${unread ? ' msg-thread-summary--unread' : ''}`}
      onClick={onOpen}
      aria-label={`${replyCountLabel(summary.reply_count)}${unread ? ', new replies' : ''}, last reply ${when}. Open thread`}
    >
      {unread && <span className="msg-thread-summary__dot" aria-hidden />}
      <span className="msg-thread-summary__faces" aria-hidden>
        {summary.repliers.map((r) => (
          <span
            key={`${r.kind}:${r.id}`}
            className={`msg-thread-summary__face${r.kind === 'agent' ? ' msg-thread-summary__face--agent' : ''}`}
          >
            {initial(r.name)}
          </span>
        ))}
      </span>
      <span className="msg-thread-summary__count">{replyCountLabel(summary.reply_count)}</span>
      <span className="msg-thread-summary__when">Last reply {when}</span>
    </button>
  )
}

function initial(name: string): string {
  const ch = [...name.trim()][0]
  return ch ? ch.toUpperCase() : '?'
}
